import api from './api';

// Obtener preps de una tienda (con par / reorder point)
export const getPrepsByStore = async (storeId) => {
  try {
    const response = await api.get(`/prep-by-store/store/${storeId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener pre-batch de la tienda:', error);
    throw error;
  }
};

// Actualizar par / reorder point de un prep
export const updatePrepParReorder = async (id, par, reorderPoint) => {
  try {
    const response = await api.put(`/prep-by-store/${id}`, { par, reorderPoint });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar pre-batch de la tienda:', error);
    throw error;
  }
};